import GetCalendarFoldersResponse from 'owa-service/lib/contract/GetCalendarFoldersResponse';
import getCalendarFoldersOperation from 'owa-service/lib/operation/getCalendarFoldersOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import { getCalendarFoldersFromSessionData } from '../services/calendarFoldersFromSessionData';
import { getUserMailboxInfo, isDefaultMailbox } from 'owa-client-ids';
import { getDefaultRequestOptions } from 'owa-headers';

export async function getCalendarsService(mailboxId?: string): Promise<GetCalendarFoldersResponse> {
    let response = null;

    // for primary account, try getting the calendarFolders from session data
    if (!mailboxId || isDefaultMailbox(mailboxId)) {
        response = getCalendarFoldersFromSessionData();
    }

    if (!response) {
        let options = getDefaultRequestOptions(getUserMailboxInfo(mailboxId));
        response = await getCalendarFoldersOperation({ Header: getJsonRequestHeader() }, options);
    }
    return response;
}
